// @ts-ignore
/* eslint-disable */
import { request } from '../../request'

/** No comments are provided by the backend POST /import */
export async function importControllerImport(
  body: {},
  file?: File,
  options?: { [key: string]: any },
) {
  const formData = new FormData()

  if (file) {
    formData.append('file', file)
  }

  Object.keys(body).forEach((ele) => {
    const item = (body as any)[ele]

    if (item !== undefined && item !== null) {
      if (typeof item === 'object' && !(item instanceof File)) {
        if (item instanceof Array) {
          item.forEach((f) => formData.append(ele, f || ''))
        } else {
          formData.append(ele, JSON.stringify(item))
        }
      } else {
        formData.append(ele, item)
      }
    }
  })

  return request<any>('/import', {
    method: 'POST',
    data: formData,
    requestType: 'form',
    ...(options || {}),
  })
}
